export interface AuthUser {
  uid: string;
  email: string;
  name: string;
  picture?: string;
}

export interface AuthClient {
  current(): AuthUser | null;
  onChange(cb: (u: AuthUser | null) => void): () => void;
  signIn(): Promise<void>;
  signOut(): Promise<void>;
  getIdToken(forceRefresh?: boolean): Promise<string | null>;
}

export class SignInError extends Error {
  readonly kind: "non_atatus" | "popup_closed" | "network" | "other";

  constructor(kind: SignInError["kind"], message: string) {
    super(message);
    this.kind = kind;
  }
}

let client: Promise<AuthClient> | null = null;

export function getAuthClient(): Promise<AuthClient> {
  if (!client) {
    client =
      import.meta.env.VITE_MOCK === "1"
        ? import("@/mocks/auth").then((m) => m.createMockAuthClient())
        : import("./firebase").then((m) => m.createFirebaseAuthClient());
  }
  return client;
}

export function resetAuthClientForTests() {
  client = null;
}
